var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.988,14.031c0.078-0.089,0.441-0.37,1.865-0.37l4.674-0.002c1.52,0,2.756-1.236,2.756-2.75V2.76\r\n\tc0-1.513-1.234-2.747-2.752-2.751l-6.94-0.01c-4.284,0-7.927,1.41-10.532,4.076c-2.594,2.656-3.965,6.363-3.965,10.719v4.396H2.783\r\n\tc-1.52,0-2.756,1.231-2.756,2.749v8.774c0,1.516,1.236,2.75,2.756,2.75h5.311v20.481c0,1.514,1.235,2.747,2.757,2.747h9.1\r\n\tc1.521,0,2.759-1.233,2.759-2.747V33.463h6.49c1.52,0,2.756-1.234,2.756-2.748l0.004-8.774c0-0.996-0.543-1.918-1.419-2.406\r\n\tc-0.407-0.225-0.878-0.345-1.364-0.345h-6.467v-3.472C22.709,14.586,22.859,14.177,22.988,14.031z"}));
}

FacebookInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"32.31px","height":"56.69px","viewBox":"0 0 32.31 56.69","enableBackground":"new 0 0 32.31 56.69","xmlSpace":"preserve"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
